// src/components/Contact.js

import React from "react";
import { useForm, ValidationError } from '@formspree/react';

export default function Contact() {
  const [state, handleSubmit] = useForm("xvonbnge");
  if (state.succeeded) {
      return (
      <>
<div
  class="mb-3 inline-flex w-full items-center rounded-lg bg-success-100 py-5 px-6 text-base text-success-700"
  role="alert">
  <span class="mr-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      class="h-5 w-5">
      <path
        fill-rule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
        clip-rule="evenodd" />
    </svg>
  </span>
  Thank you!
</div>      </>
      );
  }

  return (<>
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
      <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            style={{ filter: "opacity(0.7)" }}
            src="https://www.google.com/maps/embed/v1/place?q=Aparri,+Cagayan,+Cagayan,+Philippines&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
          />
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1 text-gray-400">
                De Carreon St., Punta <br />
                Aparri, Cagayan
                Philippines
              </p>
            </div>
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a href="mailto:neil.silao@yahoo.com" className="text-indigo-400 leading-relaxed">
                neil.silao@yahoo.com
              </a>
              <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
                PHONE
              </h2>
              <a href="tel:+639284471888" className="leading-relaxed text-gray-400">+63-928-447-1888</a>
            </div>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
    <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed mb-5">
          Neil is always available for side collaborations and talks worldwide. If you want to chat about Web sites or anything else, don’t hesitate in reaching out.</p>
    <div className="relative mb-4">

<label htmlFor="name" className="leading-7 text-sm text-gray-400">
  Name
</label>
<input
  id="name"
  type="text" 
  name="name"
  className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
/>

<ValidationError 
  prefix="Name" 
  field="name"
  errors={state.errors}
/>
    </div>



    <div className="relative mb-4">

    <label htmlFor="email" className="leading-7 text-sm text-gray-400">
      Email Address
    </label>
    <input
      id="email"
      type="email" 
      name="email"
      className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
    />

    <ValidationError 
      prefix="Email" 
      field="email"
      errors={state.errors}
    />
        </div>

    <div className="relative mb-4">
            <label
              htmlFor="message"
              className="leading-7 text-sm text-gray-400">
              Message
            </label>

    <textarea
      id="message"
      name="message"
      className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
    />
    <ValidationError 
      prefix="Message" 
      field="message"
      errors={state.errors}
    />
    </div>

    <button type="submit" disabled={state.submitting} className="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
      Submit
    </button>
  </form>
  </div>

  </section>

  </>);
}